import { Static, Type } from '@sinclair/typebox'

export const GetFairQueueStatsRequest = Type.Object({
    // Comma-separated tenant IDs. Omitted → every tenant currently contending
    // for the queue.
    tenantIds: Type.Optional(Type.String()),
})

export type GetFairQueueStatsRequest = Static<typeof GetFairQueueStatsRequest>

export const FairQueueQueueStats = Type.Object({
    activeTenants: Type.Number(),
    maxWorkers: Type.Number(),
    fairShare: Type.Number(),
    busyWorkers: Type.Number(),
    reservedSlots: Type.Number(),
    waitingJobs: Type.Number(),
})

export type FairQueueQueueStats = Static<typeof FairQueueQueueStats>

export const FairQueueGlobalStats = Type.Object({
    machinesOnline: Type.Number(),
    queues: Type.Record(Type.String(), FairQueueQueueStats),
})

export type FairQueueGlobalStats = Static<typeof FairQueueGlobalStats>

export const FairQueueTenantStats = Type.Object({
    tenantId: Type.String(),
    totalJobsProcessed: Type.Number(),
    rejectedJobs: Type.Number(),
    servedJobs: Type.Number(),
    activeJobsByQueue: Type.Record(Type.String(), Type.Number()),
    pendingJobsByQueue: Type.Record(Type.String(), Type.Number()),
})

export type FairQueueTenantStats = Static<typeof FairQueueTenantStats>

export const FairQueueStats = Type.Object({
    global: FairQueueGlobalStats,
    tenants: Type.Array(FairQueueTenantStats),
})

export type FairQueueStats = Static<typeof FairQueueStats>
